// extracted by mini-css-extract-plugin
export var elevation0 = "Paper-module--elevation0--0e88c";
export var hero = "Paper-module--hero--1af60";
export var hover = "Paper-module--hover--6a1bd";
export var padded = "Paper-module--padded--2a021";
export var root = "Paper-module--root--fa2eb";